import React from 'react'
import Image from '../../../images/sellerpolicies/23.png'

const Termination_and_duration = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>TERMINATION & DURATION</h2>
            <p>This agreement remains valid for one year extendable by tacit agreement until one of the parties terminates it.</p>
            <p>If at any time Seller decide you can no longer agree to these Terms of Agreement you must immediately stop using the Platform.</p>
            <p>The Seller may terminate this agreement by means of thirty (30) Days’ notice by emailing close@kaay.pk and the seller account will be deactivated after clearance of financial outstanding from KAAY or from the seller to either party.</p>
        </div>
      </div>
    </div>
  )
}

export default Termination_and_duration
